/** 房间号相关的纯函数与常量：不访问 document / window / localStorage / 网络。 */

/** PeerJS 上的房间号前缀（房主 peer id = ROOM_PREFIX + 房间号）。 */
export const ROOM_PREFIX = 'fogxq-'

/** 房间号长度。 */
export const ROOM_CODE_LENGTH = 6

/** 建立连接的超时时间（毫秒）。 */
export const DEFAULT_CONNECT_TIMEOUT_MS = 20000

/**
 * 房间号字符集：剔除了易混淆的 I / O / 0 / 1，避免房主念错、加入方输错。
 */
const ROOM_CODE_CHARSET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'

const ROOM_PREFIX_UPPER = ROOM_PREFIX.toUpperCase()

const ROOM_CODE_PATTERN = new RegExp(`^[${ROOM_CODE_CHARSET}]{${ROOM_CODE_LENGTH}}$`)

/** 生成房间号；`len` 缺省为 ROOM_CODE_LENGTH。 */
export function randomCode(len: number = ROOM_CODE_LENGTH): string {
  const length = Number.isFinite(len) ? Math.max(0, Math.trunc(len)) : ROOM_CODE_LENGTH
  let code = ''
  for (let i = 0; i < length; i++) {
    code += ROOM_CODE_CHARSET[Math.floor(Math.random() * ROOM_CODE_CHARSET.length)]
  }
  return code
}

/** 去空格、转大写、剥离可能存在的 `fogxq-` 前缀。 */
export function normalizeRoomCode(input: string): string {
  const compact = input.replace(/\s+/g, '').toUpperCase()
  return compact.startsWith(ROOM_PREFIX_UPPER) ? compact.slice(ROOM_PREFIX_UPPER.length) : compact
}

/** 判断（规范化之后的）输入是否是合法房间号。 */
export function isRoomCode(input: string): boolean {
  return ROOM_CODE_PATTERN.test(normalizeRoomCode(input))
}
